import { HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { EventNotificationsServiceBase } from '../../event-notifications.service-base';
import { EmailStatusesNotificatorBase } from './email-statuses-notificator-base';

export class SaleStatusesNotificatorBase extends EmailStatusesNotificatorBase {
    protected url = TaggedUrl.join('documents/:id/email/status/last', [Tags.Api, Tags.OmitMessage]);
    protected kind = 'Sale';

    public constructor(
        eventNotifications: EventNotificationsServiceBase,
        http: HttpService
    ) {
        super(eventNotifications, http);
    }
}
